import axios from "axios";
import {
    authHeader,
    handleResult,
    handleException,
    globalStore
} from '../helpers';

export const expensesService = {
    getAllProcessed,
    downloadReceipt,
    downloadAllProcessedAsExcel,
    downloadAllProcessedAsZip,
    mailExpenses
};

function getAllProcessed(companyId, selectedDate) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.get("salaryspecification/expenses/" + companyId + "/" + selectedDate, requestOptions)
        .then(handleResult);
}

function mailExpenses(mailExpensesRequest) {
    const requestOptions = {
      headers: authHeader()
    };
  
    return axios.post("expenses/mail", mailExpensesRequest, requestOptions)
      .then(handleResult).catch(handleException);
  }

function downloadAllProcessedAsExcel(expenses) {
    return downloadFile('POST', 'expenses/excel', "expenses.xlsx", expenses);
}

function downloadAllProcessedAsZip(expenses) {
    return downloadFile('POST', 'expenses/receipts', "expenses.zip", expenses);
}

function downloadReceipt(expense) {
  axios({
    url: "expenses/" + expense.id + "/receipt",
    method: "GET",
    headers: authHeader(),
    responseType: "blob" // important
  }).then(response => {
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", expense.receiptFileName); //or any other extension
    document.body.appendChild(link);
    link.click();
  });
}


function downloadFile(method, url, fileName, data) {
    return axios({
        url: url,
        method: method,
        data: data,
        headers: authHeader(),
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download", fileName
        );
        document.body.appendChild(link);
        link.click();
      });
}